// extracted by mini-css-extract-plugin
export var box = "_70-1";
export var checked = "_70-2";
export var descriptionSpacer = "_70-9";
export var disabled = "_70-3";
export var icon = "_70-6";
export var input = "_70-0";
export var labelSpacer = "_70-8";
export var medium = "_70-5";
export var small = "_70-4";
export var text = "_70-7";